import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Slider from 'antd/lib/slider';
import InputNumber from 'antd/lib/input-number';
import accounting from 'accounting';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { BID_REQUEST_EXPIRATION_TIME } from '../../../store/reducers/ProjectView';
import { Button } from '../../Button';
import './BidSubmission.css';

class BidSubmission extends Component {
  constructor(props) {
    super(props);
    this.onBidChange = this.onBidChange.bind(this);
  }

  onBidChange(bid) {
    const { setValues } = this.props;
    setValues({ bid });
  }

  render() {
    const {
      project: { price_selected: budget },
      project,
      values: { bid },
      handleSubmit,
    } = this.props;

    const minBudget = Math.round(budget / 2);
    const maxBudget = Math.round(budget * 3);

    return (
      <form onSubmit={handleSubmit}>
        <div className="bid-submission">
          <div className="bid-submission__description-container">
            <div>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
              lacinia urna in congue aliquam. Maecenas finibus.
            </div>
          </div>
          <div className="bid-submission__recommended-price-container">
            <div className="bid-submission__recommended-price--label">
              Submit Before
            </div>
            <div className="bid-submission__recommended-price--value">
              {moment(project.bid_info.last_bid_created_at, 'YYYY-MM-DD')
                .add(BID_REQUEST_EXPIRATION_TIME, 'hours')
                .format('MM/DD/YYYY')}
            </div>
          </div>
          <div className="bid-submission__recommended-price-container">
            <div className="bid-submission__recommended-price--label">
              Client Budget
            </div>
            <div className="bid-submission__recommended-price--value">
              ${accounting.format(budget)}
            </div>
          </div>
          <div className="bid-submission__selected-price-container">
            <div className="bid-submission__selected-price--label">
              Price Selected
            </div>
            <InputNumber
              className="bid-submission__selected-price--value"
              min={minBudget}
              max={maxBudget}
              formatter={value =>
                `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
              value={bid}
              onChange={this.onBidChange}
            />
          </div>
          <div className="bid-submission__recommended-price-container">
            <Button
              className="payment-card__actions-button"
              rounded
              type="submit"
              title="Submit bid"
            />
          </div>
          <div className="bid-submission__footer-container">
            <Slider
              className="bid-submission__footer-slider"
              min={minBudget}
              max={maxBudget}
              tipFormatter={null}
              value={bid}
              onChange={this.onBidChange}
            />
          </div>
        </div>
      </form>
    );
  }
}

BidSubmission.propTypes = {
  setValues: PropTypes.func,
  project: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default withFormik({
  mapPropsToValues: ({ project: { price_selected: bid } }) => ({
    bid,
  }),
  handleSubmit: (values, { props, setSubmitting }) =>
    props.handleSubmitBid && props.handleSubmitBid(values, setSubmitting),
  validateOnBlur: true,
  validateOnChange: true,
  validationSchema: Yup.object().shape({
    bid: Yup.string(),
  }),
  displayName: 'BidSubmissionForm',
})(BidSubmission);



// WEBPACK FOOTER //
// ./src/components/ProjectView/BidSubmission/BidSubmission.js